import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class EncrDecrServiceProvider {
  constructor(public http: Http) {
    console.log('Hello EncrDecrServiceProvider Provider');
  }
  //The set method is use for encrypt the value.
  set(keys, value) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    // var encrypted = CryptoJS.AES.encrypt(value, keys, { format: JsonFormatter });
    return encrypted.toString();
  }

  //The get method is use for decrypt the value.
  get(keys, value) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    // var decrypted = CryptoJS.AES.decrypt(value, keys, { format: JsonFormatter });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }


  //The set method is use for encrypt the value.
  encrypt(keys, value) {
    /*
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    */
    var encrypted = CryptoJS.AES.encrypt(value, keys);
    return encrypted.toString();
  }

  //The get method is use for decrypt the value.
  decrypt(keys, value) {
    /*
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    */
    var decrypted = CryptoJS.AES.decrypt(value, keys);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

}



// WEBPACK FOOTER //
// ./src/providers/encr-decr-service/encr-decr-service.ts